import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { LocalizedString } from '../localized-string.model';
import { LocalizeService } from './localize.service';

@Pipe({
  name: 'localize',
  standalone: true,
})
export class LocalizePipe implements PipeTransform {
  constructor(private readonly localizeService: LocalizeService) {}

  transform(value: LocalizedString | string): Observable<string> {
    if (typeof value === 'string') {
      return of(value);
    }
    return this.localizeService.localize(value);
  }
}
